window.roundupInitializer = function () {
    var roundUpVariantId = window.ROUNDUP_VARIANT_ID;
    window.roundupChecking = false;

    function afterFinish(target) {
      var $target = jQuery(target);
      if ($target.attr("href")) {
        window.location.href = $target.attr("href");
        return;
      }

      $target.trigger("click");
    }

    function handleRoundUp(ev) {
      if (window.roundupChecking) return true;
      console.log("checkout clicked...");
      ev.preventDefault();
      ev.stopPropagation();
      window.roundupChecking = true;
      var addRoundUp = jQuery(".round_up_checkbox").prop("checked");
      var quantity = parseInt(jQuery(".roundup_donation_amount").val());

      console.log("addRoundUp: " + addRoundUp);
      console.log("donation amount: " + quantity);
      jQuery.getJSON("/cart.js", function (cart) {
        var roundProdExist = false;

        var cartQuantity = 0;
        jQuery.each(cart.items, function (index, value) {
          if (value.id == roundUpVariantId) {
            cartQuantity = value.quantity;
            roundProdExist = true;
          }
        });

        if (addRoundUp && !roundProdExist) {
          var params = {
            type: "POST",
            url: "/cart/add.js",
            async: false,
            data: "quantity=" + quantity + "&id=" + roundUpVariantId,
            dataType: "json",
            success: function () {
              console.log("add success...");
              afterFinish(ev.target);
            },
          };
          jQuery.ajax(params);
          console.log("add roundup prod");
        } else if (
          (!addRoundUp && roundProdExist) ||
          (addRoundUp && cartQuantity != quantity)
        ) {
          if (!addRoundUp) {
            quantity = 0;
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/update.js",
            async: false,
            data: "updates[" + roundUpVariantId + "]=" + quantity,
            dataType: "json",
            success: function () {
              console.log("update/remove success...");
              afterFinish(ev.target);
            },
          });
          console.log("update/remove roundup prod");
        } else {
          afterFinish(ev.target);
        }
      });

      return false;
    }

    jQuery("body").on("click", 'button[name="checkout"]', handleRoundUp);
  };